import React from 'react';
import { PlayCircle } from 'lucide-react';
import { motion } from 'framer-motion';

export function VideoSection() {
  return (
    <section className="py-12 sm:py-20 bg-gray-50 dark:bg-gray-800/50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3">
            Decouvrez Globe PVT en video
          </h2>
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Pvtistes.net recommande l'assurance Globe PVT depuis 2005. Decouvrez pourquoi il est important d'avoir une bonne assurance en PVT.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="aspect-video w-full rounded-2xl overflow-hidden shadow-xl bg-gray-900"
        >
          <iframe
            src="https://www.youtube.com/embed/dEv0Bs2jviY"
            title="Presentation Globe PVT"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          />
        </motion.div>
      </div>
    </section>
  );
}
